/* global scrollLock */
import vars from '../helpers';
import animate from '../components/animation';
import analytics from '../components/analytics';

const routes = {
	'/': {
		id: false,
		title: 'Эпоха искусственного интеллекта',
		description: 'Современную жизнь невозможно представить без автоматизации — повседневные рутинные задачи всё чаще отдаются на обработку алгоритмам и механизмам',
	},
	'/idealnyy-instrument': {
		id: '#article1',
		title: 'Искусственный интеллект - идеальный инструмент',
		description: 'Искусственный интеллект — это помощник и друг человека. Не стоит воспринимать его как претендента на ваши рабочие места',
	},
	'/issledovatelskiy-interes': {
		id: '#article2',
		title: 'Искусственный интеллект в системе здравоохранения',
		description: 'ИИ в системе здравоохранения и медицине в целом — поддержка в принятии решений. Это не значит, что диагноз ставит компьютер, это лишь помощь специалистам, более качественная, чем справочник',
	},
	'/ischezayushcheye-izobiliye': {
		id: '#article3',
		title: 'Искусственный интеллект в экологии',
		description: 'Экология стала ещё одним вызовом для разработчиков нейросетей, самообучающихся программ и сложных алгоритмов. Многие проблемы с озеленением, восстановлением популяций и использованием природных ресурсов сегодня пытаются решить при помощи искусственного интеллекта',
	},
};
const pathname = document.location.pathname.replace('/iskusstvenniy-intellekt', '');
let headDescription = document.querySelector('meta[name="description"]') ? document.querySelector('meta[name="description"]') : false;

const homeSeo = (section) => {
	history.replaceState(null, null, `${vars.path}${section.dataset.urlpach ? section.dataset.urlpach : ''}${vars.search}`);

	Object.entries(routes).forEach(([key]) => {
		if (key === `/${section.dataset.urlpach ? section.dataset.urlpach : ''}`) {
			if (document.title) {
				document.title = routes[key].title;
			}

			if (headDescription) {
				headDescription.setAttribute('content', routes[key].description);
			}
		}
	});

	analytics.init(document.location.href, document.title);
};

const homeAnimate = () => {
	let tlIntro = gsap.timeline();
	let gsapMedia = gsap.matchMedia();
	const headerLogo = vars.header.querySelector('.header__logo');
	const introTitle = document.querySelector('.intro__title');
	const introSubitle = document.querySelector('.intro__subtitle');
	const homeSection = document.querySelectorAll('.home__section');
	const articleTitle = document.querySelectorAll('.intro__description, .article__title');
	const articleImage = document.querySelectorAll('.article__graphic11, .article__image11, .article__graphic22, .article__graphic31');

	animate.fade(vars.home, tlIntro, 1, 0.5);
	animate.fade(vars.header, tlIntro, 0.5, false, '<');
	gsap.matchMedia().add('(min-width: 1025px)', () => {
		tlIntro.to(vars.social, {
			onStart() {
				vars.social.classList.remove('is-hidden');
			},
			duration: 0.5,
			opacity: 1,
			ease: 'Power1.easeOut',
			clearProps: 'all',
		});
	});
	animate.fadeUp(introTitle, tlIntro, false, false);
	animate.text(introSubitle, tlIntro, 0.7, false);
	animate.fadeDown(headerLogo, tlIntro, false, false, '-=50%');

	homeSection.forEach((section) => {
		gsap.from(section, {
			scrollTrigger: {
				trigger: section,
				start: '-20px top',
				end: '99% top',
				scrub: true,
				onEnter: () => homeSeo(section),
				onEnterBack: () => homeSeo(section),
			},
			ease: 'none',
		});
	});

	gsapMedia.add('(min-width: 1025px)', () => {
		articleImage.forEach((el) => {
			gsap.to(el, {
				scrollTrigger: {
					trigger: el,
					start: 'top center',
					end: 'bottom center',
					scrub: 1,
				},
				duration: vars.duration,
				y: 100,
				ease: 'none',
			});
		});
	});

	gsap.to(vars.burger, {
		scrollTrigger: {
			trigger: '.home__section--article1',
			start: '-20px top',
			end: 'top top',
			scrub: true,
		},
		duration: vars.duration,
		opacity: 1,
		x: 0,
		ease: 'none',
	});

	articleTitle.forEach((el) => {
		gsap.from(el, {
			scrollTrigger: {
				trigger: el,
				start: 'top 85%',
				end: 'center 85%',
				scrub: 1,
			},
			duration: vars.duration,
			opacity: 0,
			y: 80,
			ease: 'none',
		});
	});

	vars.links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			if (vars.burger.classList.contains('is-menu')) {
				vars.burger.click();
			}

			animate.scrollTo(link.getAttribute('href'), false, 0.3);
		});
	});
};

const homeLoad = () => {
	let currentRoute = null;

	Object.entries(routes).forEach(([key]) => {
		if (pathname.indexOf(key) >= 0) {
			currentRoute = key;
		}
	});

	if (currentRoute === null) {
		return;
	}

	if (routes[currentRoute].id) {
		gsap.to(window, {
			onComplete() {
				homeAnimate();
			},
			duration: 0.01,
			scrollTo: routes[currentRoute].id,
		});
	} else {
		homeAnimate();
		analytics.init(document.location.href, document.title);
	}
};

const homeInit = homeLoad;

export {homeInit};
